// src/components/Nav.js
import React from 'react';
import { Box, Link as MuiLink, IconButton } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '@mui/material/styles';
import { useColorMode } from '../App';

export default function Nav() {
  const theme = useTheme();
  const { toggleColorMode } = useColorMode();
  const { pathname } = useLocation();

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 2, sm: 4 },
        py: 1.5,
        backdropFilter: 'blur(8px)',
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(18,18,18,0.75)' : 'rgba(255,255,255,0.75)'
      }}
    >
      <MuiLink
        component={RouterLink}
        to="/"
        underline="none"
        color="text.primary"
        sx={{ fontFamily: 'Quicksand, sans-serif', fontWeight: 700 }}
      >
        🎀 Cristina Fortiz
      </MuiLink>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <MuiLink
          component={RouterLink}
          to="/projects"
          underline="none"
          color={pathname === '/projects' ? 'primary' : 'text.secondary'}
          sx={{ fontWeight: 500 }}
        >
          Projects
        </MuiLink>
        <IconButton onClick={toggleColorMode} size="small">
          {theme.palette.mode === 'dark' ? <Brightness7Icon fontSize="small" /> : <Brightness4Icon fontSize="small" />}
        </IconButton>
      </Box>
    </Box>
  );
}
